/*******************************************************************
* PAGE        : TabComponent
* REMARKS     : Comman Tab Component
* CREATED ON  : 03-11-2025
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 30-03-2026
********************************************************************/

import React from 'react';

import './TabComponent.css'

const TabComponent = ({ TabData, activeTabId, onClick }) => (
    <div className="custom-tabs-container">
        {TabData.map((item) => (
            item && <div key={item.id} className={`custom-tab ${item.id === activeTabId ? "active" : ""}`} onClick={() => onClick(item.id)}>
                {item.label}
            </div>
        ))}
    </div>
);

export default TabComponent;
